import React, { useContext } from 'react';
import { UserOrderContext } from 'context/context';
import { useSelector } from 'react-redux';
import { ButtonComp } from 'atoms/Buttons';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { checkAnyObjValTrue, getLength, getTernaryValue } from 'common/utilities/utils';
import ProductCustomizeToppingAccordion from './ProductCustomizeToppingAccordion';
import PRODUCT_CONSTANTS from 'organisms/ProductListingModalOptions/AU/Constants/ProductListingModalOptionsConstants';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import PRODUCT_CUSTOM_CONSTANTS from '../Constants/CustomizationConstants';
import ImageComponent from 'atoms/Image';
import ToastModalComponent from 'molecules/toastModal';
import { getClassNameForBtnDisabled } from 'molecules/QuantityModifierAddToCart/QuantityModifierAddToCart';
import { CHECKOUT_CONSTANTS, priceFixed_value } from 'common/constants/SharedConstants';

const getClassNameForPrice = updatedPrice => {
  return updatedPrice !== 0 ? 'confirmButtonWithPrice' : '';
};
/**
 * Product List Form
 * @param {*} props - Object
 */

const ProductCustomModalForm = props => {
  const {
    data,
    confirmHandler,
    showPriceContent = true,
    isModal,
    onDismissedSelection,
    isStoreClosed,
    localized,
    catalog,
  } = props;
  const { modgrps } = data;
  const { CONFIRMBUTTONTXT } = PRODUCT_CONSTANTS;
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { currencySymbol, currencyConversionFactor } = tenantReducer;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { sopacPDPCustomization, pdpPayloadData, pdpAddtoCartConfirmButtonDisabled } = userOrderState;
  const { updatedPrice = 0 } = sopacPDPCustomization;
  const { ErrorImage, PopupCloseBtn } = IMAGE_PATH;
  const { SHOWTOASTALERT } = MENU_PDP_PAGE_CONSTANTS;
  const { DISMISS_CHANGES_ALERT_TEXT, DISMISS_SELECTIONS } = PRODUCT_CUSTOM_CONSTANTS;
  const { PLUS, DASH } = CHECKOUT_CONSTANTS;

  const computePrice = updatedPriceVal => {
    return (updatedPriceVal / currencyConversionFactor).toFixed(priceFixed_value);
  };

  const getPriceText = updatedPriceVal => {
    const updatedPriceAbsolute = updatedPriceVal >= 0 ? updatedPriceVal : updatedPriceVal.toString().replace(/^-/, '');
    const price = `${currencySymbol}${computePrice(updatedPriceAbsolute)}`;
    return getTernaryValue(updatedPriceVal > 0, `${PLUS} ${price}`, `${DASH} ${price}`);
  };

  const onCloseToast = () => {
    userOrderStateDispatch({ type: SHOWTOASTALERT, value: false });
  };

  const childrenTemplate = (
    <div className='img-text-div'>
      <div className='text'>
        <div className='titleImg-container'>
          <ImageComponent className='error-image' srcFile={ErrorImage} />
          <p>{translateWithI18Next(DISMISS_CHANGES_ALERT_TEXT)}</p>
        </div>
        <ButtonComp onClick={() => onDismissedSelection(pdpPayloadData)} className='dismiss'>
          {translateWithI18Next(DISMISS_SELECTIONS)}
        </ButtonComp>
      </div>
      <ButtonComp className='custom-modal-close' data-testid='custom-modal-close' onClick={onCloseToast}>
        {' '}
        <ImageComponent srcFile={PopupCloseBtn} />
      </ButtonComp>
    </div>
  );
  const alertToast = (
    <ToastModalComponent
      id='PDPToastAlert'
      role='dialog'
      show={true}
      classNames='savedCustomizeClearAlert-modal'
      closeDataTestId='handler-close'
      autoFocus={true}
      childrenTemplate={childrenTemplate}
    />
  );

  return (
    <React.Fragment>
      <div className='modal-body-row product-listing-component' data-testid='product-listing-component'>
        <form className='form'>
          {getLength(modgrps) ? (
            <ProductCustomizeToppingAccordion
              grouplist={modgrps}
              getSelectedModifiers={null}
              selectedModifiers={null}
              tenantData={tenantReducer}
              isModal={isModal}
              isStoreClosed={isStoreClosed}
              localized={localized}
              catalog={catalog}
            />
          ) : null}
        </form>
      </div>
      {showPriceContent && (
        <div className='price-content price-content-sopac'>
          <div className='price-content-parent price-content-parent-sopac' data-testid='product-listing-button-comp'>
            <ButtonComp
              className={`button start-order-btn redButton  confirmButton ${getClassNameForPrice(
                updatedPrice,
              )} ${getClassNameForBtnDisabled(pdpAddtoCartConfirmButtonDisabled)}`}
              id='startOrderItemButton'
              data-testid='product-listing-button'
              type='submit'
              name={'product-listing-button'}
              onClickHandler={confirmHandler}
              disabled={checkAnyObjValTrue(pdpAddtoCartConfirmButtonDisabled)}
            >
              <span>{translateWithI18Next(CONFIRMBUTTONTXT)}</span>
              {getTernaryValue(updatedPrice !== 0, getPriceText(updatedPrice), '')}
            </ButtonComp>
          </div>
        </div>
      )}
      {userOrderState.showToastAlert && alertToast}
    </React.Fragment>
  );
};

export default ProductCustomModalForm;
